<template>
  <v-dialog v-model="dialogActive" width="500" @click:outside="closeDialog">
    <v-card>
      <v-btn style="float: right" icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-col align="center" class="px-5">
        <v-icon x-large color="success" class="mb-5"> mdi-check-circle </v-icon>

        <p class="mb-5">{{ $translate('ITEMS_ADDED_TO_BASKET') }}</p>

        <!-- Show failed products with capacity error -->
        <v-alert
          v-if="hasProductsWithCapacityError"
          text
          outlined
          type="error"
          class="mt-3 mb-0 pa-2"
        >
          <v-col class="pa-0 text-start">
            <div class="text-subtitle-2 font-weight-medium">
              {{ $translate('FAILED_PRODUCTS_CAPACITY_ERROR') }}:
            </div>
            <div class="text-subtitle-1 font-weight-bold">
              {{ productsWithCapacityError }}
            </div>
          </v-col>
        </v-alert>

        <!-- Show failed products that are already in shopping cart -->
        <v-alert
          v-if="hasProductsAlreadyInCart"
          text
          outlined
          type="info"
          class="mt-3 mb-0 pa-2"
        >
          <v-col class="pa-0 text-start">
            <div class="text-subtitle-2 font-weight-medium">
              {{ $translate('FAILED_PRODUCTS_ALREADY_IN_CART') }}:
            </div>
            <div class="text-subtitle-1 font-weight-bold">
              {{ productsAlreadyInCart }}
            </div>
          </v-col>
        </v-alert>
      </v-col>

      <v-card-actions class="pb-4">
        <v-row class="ma-0" justify="center">
          <v-col class="py-0">
            <v-btn
              block
              color="primary"
              class="mb-3 primary-font-color"
              @click="goToOrder"
            >
              {{ $translate('GO_TO_SHOPPING_CART') }}
            </v-btn>

            <v-btn block color="secondary" @click="closeDialog">
              {{ $translate('CONTINUE_SHOPPING') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddProductsToCartSuccessDialog',
  components: {},
  props: {
    dialogActiveProp: Boolean,

    /* Products not added to shopping cart due to capacity or other issues */
    failedProducts: Array,
  },
  computed: {
    productsWithCapacityError() {
      return this.getFailedProductsWithErrorCode('E_PO_006');
    },
    productsAlreadyInCart() {
      return this.getFailedProductsWithErrorCode('E_PR_001');
    },
    hasProductsWithCapacityError() {
      if (
        this.productsWithCapacityError != null &&
        this.productsWithCapacityError.trim().length > 0
      ) {
        return true;
      }

      return false;
    },
    hasProductsAlreadyInCart() {
      if (
        this.productsAlreadyInCart != null &&
        this.productsAlreadyInCart.trim().length > 0
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    dialogActiveProp() {
      this.dialogActive = this.dialogActiveProp;
    },
  },
  data() {
    return {
      dialogActive: this.dialogActiveProp,
    };
  },
  methods: {
    goToOrder() {
      this.closeDialog();

      this.$router.push({
        name: 'Booking',
      });
    },
    getFailedProductsWithErrorCode(errorCode) {
      if (this.failedProducts == null || this.failedProducts.length === 0) {
        return '';
      }

      const products = this.failedProducts.filter(
        (product) => product.Reason === errorCode
      );
      if (products == null || products.length === 0) {
        return '';
      }

      const productNamesArray = [];
      products.forEach((product) =>
        productNamesArray.push(product.ProductInfo.Name)
      );

      return productNamesArray.join(', ');
    },
    closeDialog() {
      this.dialogActive = false;
      this.$emit('close');
    },
  },
};
</script>
